export const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID;
export const GOOGLE_GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_GTM_ID;
export const RD_STATION_TOKEN = process.env.NEXT_PUBLIC_RD_STATION_TOKEN;
export const ASSETS_CDN_URL = process.env.NEXT_PUBLIC_ASSETS_CDN_URL;
